export const AUDIT_TRAIL_API = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/uje/audit`;